import React from 'react';
import PropTypes from 'prop-types';

const UserCircle = ({ color }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="12.5" cy="10.127" r="3" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <circle cx="12.5" cy="12.127" r="9" stroke={color} strokeWidth="2" />
    <path
      d="M18.2805 18.9534C18.4076 18.8836 18.4678 18.7324 18.414 18.5978C18.0284 17.6314 17.2856 16.7804 16.2814 16.1602C15.1966 15.4901 13.8674 15.127 12.5 15.127C11.1326 15.127 9.80341 15.4901 8.71858 16.1602C7.71444 16.7804 6.9716 17.6314 6.58598 18.5978C6.53223 18.7324 6.59236 18.8836 6.71948 18.9534C10.3197 20.9299 14.6803 20.9299 18.2805 18.9534Z"
      fill={color}
    />
  </svg>
);

UserCircle.propTypes = {
  color: PropTypes.string.isRequired,
};

export default UserCircle;
